const OrderType = Object.freeze({
    randomized: 'randomized',
    sequential: 'sequential'

});

export default OrderType;